<div class="carousel-item" (click)="redirectToMerchantSite(shop?.url)">
    <img class="feature-image" [src]="shop?.merchantFeaturedUrl" alt="{{shop?.merchantName}}"  (error)="handleImageError($event)" />
    <div class="merchant-details">
        <img class="merchant-logo" src="{{shop.logoUrl}}" alt="{{shop.alt}}" (error)="handleImageError($event)">
        <span class="shop-name">
            <ng-container *ngIf="shop.brandName">
                {{ textDirection == 'rtl' ?  shop.brandNameArabic : shop.brandName }}
             </ng-container>
             <ng-template #businessName>
                {{ textDirection == 'rtl' ?  shop.businessNameArabic : shop.businessName }}
             </ng-template>
        </span>
    </div>
</div>